<div class="checkbox-container" (click)="onBoxClick($event)">
  <button class="checkbox-box" type="button" role="checkbox" [attr.aria-checked]="$indeterminate() ? 'mixed' : checked()" [attr.aria-label]="$label()" [disabled]="disabled()" [attr.tabindex]="$tabindex()" (keydown)="onKeydown($event)">
    @if (checked() && !$indeterminate()) {
      <i class="fa-solid fa-check checkbox-icon"></i>
    }
    @if ($indeterminate()) {
      <i class="fa-solid fa-minus checkbox-icon"></i>
    }
  </button>
  @if ($label() || $description()) {
    <div class="checkbox-text">
      @if ($label()) {
        <span class="checkbox-label">{{ $label() }}</span>
      }
      @if ($description()) {
        <span class="checkbox-description">{{ $description() }}</span>
      }
    </div>
  }
</div>
